import { NavLink, useParams } from 'react-router-dom';
import type { GalleryYear } from '../types';

interface YearSelectorProps {
  years: GalleryYear[];
}

export default function YearSelector({ years }: YearSelectorProps) {
  const { year: activeYear } = useParams<{ year: string }>();

  if (years.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="Competition years"
      className="overflow-x-auto scrollbar-hide"
    >
      <ul className="flex gap-2 px-4 py-2 min-w-max">
        {years.map((y) => {
          const isActive = y.year === activeYear;
          return (
            <li key={y.year}>
              <NavLink
                to={`/${y.year}`}
                className={`inline-block rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-fwo-blue text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
                aria-current={isActive ? 'page' : undefined}
              >
                {y.year}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
